module.exports = __webpack_public_path__ + "static/Screenshot-6d8eca6dd4ecf34b1e7c5b6ae57c54c4.png";